import { render, staticRenderFns } from "./myDownload.vue?vue&type=template&id=81cf61f4&scoped=true&"
import script from "./myDownload.vue?vue&type=script&lang=js&"
export * from "./myDownload.vue?vue&type=script&lang=js&"
import style0 from "./myDownload.vue?vue&type=style&index=0&id=81cf61f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81cf61f4",
  null
  
)

export default component.exports